export const keepDigitsOnly = (input) => {
  return input.replace(/\D/g, '');
};
